'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { useBoolean } from '@insta-club/hooks';
import { EducationalPost } from '@insta-club/models';
import { CloseBtn, Dialog } from '@insta-club/ui';
import { formatCompactNumber } from '@insta-club/utilities';
import Image from 'next/image';
import { CircularPlayButton, EducationalPostVideo, LikeMarkActions } from 'src/libs/components/common';
import { ClockIcon } from 'src/libs/components/icons';
import Eye from 'src/libs/components/icons/eye';

function VideoItem({ video }: { video: EducationalPost }) {
    const openVideo = useBoolean();
    return (
        <>
            <div className='shadow-card rounded-[20px] bg-white p-3'>
                <div onClick={openVideo.onTrue} className='relative mb-9 cursor-pointer overflow-hidden rounded-2xl'>
                    <div className='relative aspect-[330/410] w-full overflow-hidden'>
                        <Image
                            fill
                            className='object-cover'
                            src={video.thumbnail ?? '/img-not-found-placeholder.jpg'}
                            alt='educational-post'
                            sizes='(max-width: 640px) 100vw, 100vw'
                        />
                    </div>

                    <div
                        className='absolute inset-0 z-[1] flex flex-col items-start justify-between'
                        style={{
                            background:
                                'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 0.01%, rgba(0, 0, 0, 0.656458) 60.92%, rgba(0, 0, 0, 0.8) 95.84%)'
                        }}
                    >
                        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform'>
                            <CircularPlayButton totalTime={video.time} currentTime={video.watchTime} size={100} />
                        </div>
                    </div>

                    <div className='absolute bottom-0 z-[2] flex w-full justify-between p-4'>
                        <div className='flex items-center rounded-lg bg-gray-200 p-1.5 text-sm font-normal text-gray-600'>
                            <ClockIcon className='ml-1' />
                            <span>5 ساعت و 10 دقیقه</span>
                        </div>
                        <div className='flex items-center space-x-0.5 text-white'>
                            <span>{formatCompactNumber(video.views)}</span>
                            <Eye width={16} height={16} />
                        </div>
                    </div>
                </div>

                <div className='space-y-2.5'>
                    <div className='flex items-center justify-between'>
                        <h4 className='max-w-[250px] text-base font-semibold text-gray-700'>{video.title}</h4>
                        <LikeMarkActions
                            size='sm'
                            id={Number(video.id).toString()}
                            liked={!!video.liked}
                            marked={!!video.marked}
                            buildEndpoint={(entityId, status) =>
                                ApiKeys.EDUCATIONAL_POSTS_STATUS_UPDATE(entityId, status)
                            }
                        />
                    </div>
                    <p className='text-sm font-medium text-gray-500'>{video.description}</p>
                    {/* <ProgressBar percentage={(video.watchTime / video.time) * 100} direction='rtl' /> */}
                    <div className='flex items-center'>
                        <Image
                            className='ml-1 h-7 w-7 rounded-full object-cover'
                            width={28}
                            height={28}
                            src={video.user.image ?? '/img-not-found-placeholder.jpg'}
                            alt='educational-mentor-image'
                            loading='lazy'
                        />
                        <span className='text-[13px] font-normal text-gray-500'>
                            {video.user.first_name} {video.user.last_name}
                        </span>
                    </div>
                </div>
            </div>
            <Dialog open={openVideo.value} onClose={openVideo.onFalse}>
                <div className='absolute top-4 left-4 z-50'>
                    <CloseBtn onClick={openVideo.onFalse} />
                </div>
                <EducationalPostVideo
                    item={video}
                    onTimeupdateDelay={(t) => {
                        fetcher(ApiKeys.POST_EDUCATIONAL_POST_SET_DURATION(video.id ?? 0), 'dashboard', 'POST', {
                            body: {
                                duration: t
                            }
                        });
                        // TODO GET VIDEOS NEW LIST
                        // mutate(ApiKeys.GET_APP_HELPS);
                    }}
                    onBack={() => {
                        openVideo.onFalse();
                    }}
                />
            </Dialog>
        </>
    );
}

export default VideoItem;

